import React from 'react';
import { cn } from '../lib/utils';

export const Tabs = ({ tabs, activeTab, onChange, className }) => {
  return (
    <div className={cn('flex border-b border-border', className)}>
      {tabs.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => onChange(t.id)}
          className={cn(
            'px-4 py-3 text-sm font-semibold border-b-2 -mb-px transition-colors',
            activeTab === t.id
              ? 'border-primary text-primary'
              : 'border-transparent text-muted-foreground hover:text-foreground'
          )}
          data-testid={`tab-${t.id}`}
        >
          <div className="flex items-center gap-2">
            {t.icon ? <t.icon className="w-4 h-4" /> : null}
            <span>{t.label}</span>
          </div>
        </button>
      ))}
    </div>
  );
};
